import {IConfigurationEvaluationContext} from '../../configuration-evaluation-context/configuration-evaluation-context.interface';
import {PropertiesEvaluator} from '../../properties-evaluator/properties-evaluator';
import {IPropertyEvaluator} from '../../property-evaluator/property-evaluator.interface';
import {IValueEvaluator} from '../value-evaluator.interface/value-evaluator.interface';
import {Check} from '@sparkware/app-utils';

export class ObjectEvaluator implements IValueEvaluator {
  constructor(private _object: object) {
  }

  get obj() {
    return this._object;
  }

  private _evaluatedValue: unknown = undefined;

  evaluate(context: IConfigurationEvaluationContext): any {
    if(Check.isUndefined(this._evaluatedValue)) {
      let properties: IPropertyEvaluator[] = [];

      Object.keys(this.obj).forEach(propertyName => {
        properties.push(context.createPropertyEvaluator(propertyName, this.obj));
      });

      let configEvaluator = new PropertiesEvaluator(properties);
      this._evaluatedValue = configEvaluator.evaluate(context);
    }

    return this._evaluatedValue;
  }
}
